import React from 'react';
import { getPriorityColor } from '../../utils/taskUtils';
import TaskList from './TaskList';

const PriorityColumn = ({ title, tasks, level, emptyMessage }) => {
  const colorClass = getPriorityColor(level);

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center mb-4">
        <h3 className={`text-lg font-semibold `}>
          {title} ({tasks.length})
        </h3>
      </div>
      
      <TaskList 
        tasks={tasks} 
        showTimestamps={false}
        emptyMessage={emptyMessage}
      />
    </div>
  );
};

export default PriorityColumn;